var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1665 3.5C1.1665 2.53325 1.94975 1.75 2.9165 1.75H11.0832C11.4053 1.75 11.6665 2.01117 11.6665 2.33333C11.6665 2.6555 11.4053 2.91667 11.0832 2.91667H2.9165C2.59409 2.91667 2.33317 3.17758 2.33317 3.5C2.33317 3.82242 2.59409 4.08333 2.9165 4.08333H8.1665C8.48867 4.08333 8.74984 4.3445 8.74984 4.66667C8.74984 4.98883 8.48867 5.25 8.1665 5.25H2.9165C1.94975 5.25 1.1665 4.46675 1.1665 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33317 4.08333H11.6665C12.3111 4.08333 12.8332 4.60542 12.8332 5.25V11.0833C12.8332 11.7279 12.3111 12.25 11.6665 12.25H2.9165C1.94992 12.25 1.1665 11.4666 1.1665 10.5V3.5L2.33317 4.08333ZM10.2082 8.75C10.6914 8.75 11.0832 8.35825 11.0832 7.875C11.0832 7.39175 10.6914 7 10.2082 7C9.72492 7 9.33317 7.39175 9.33317 7.875C9.33317 8.35825 9.72492 8.75 10.2082 8.75Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.f3ce1df0c64769d6554825a3566f3eb5.svg";
export { ForwardRef as ReactComponent };